import { DataDictionaryQueryParams } from './DataDictionary';
import { PoweredByArovy } from '@ui/icons';
import { SharedDataDictionaryTable } from './SharedDataDictionaryTable';

import { coreActions, GetSharedDataDictionaryResponse } from '@sonar-software/sonar-core';
import React, { useCallback, useMemo } from 'react';
import { useAction, useQueryParams } from '@hooks';

export type SharedDataDictionaryQueryParams = DataDictionaryQueryParams & {
	filterByName?: string,
	sharedKey: string;
};

export interface SharedDataDictionaryProps {
	data: GetSharedDataDictionaryResponse | null | undefined;
	loading: boolean;
	viewKey: string;
}

export const SharedDataDictionary: React.FC<SharedDataDictionaryProps> = ({ data, loading, viewKey }) => {
	const requestView = useAction(coreActions.requestGetCoreDataDictionaryViewsSharedKey);

	const initialParams: SharedDataDictionaryQueryParams = useMemo(
		() => ({
			count: 10,
			filterByName: undefined,
			sharedKey: viewKey
		}),
		[ viewKey ]
	);

	const handleUpdate = useCallback(
		(
			_: Partial<SharedDataDictionaryQueryParams>,
			__: SharedDataDictionaryQueryParams | undefined,
			combined: SharedDataDictionaryQueryParams
		) => {
			requestView(combined);
		},
		[ requestView ]
	);

	const { updateParams } = useQueryParams<SharedDataDictionaryQueryParams>({
		defaultParams: initialParams,
		onUpdate: handleUpdate
	});

	return (
		<>
			<SharedDataDictionaryTable
				loading={ loading }
				resource={ data }
				updateQuery={ updateParams } />
			<PoweredByArovy className='shared-view-footer-logo' />
		</>
	);
};
